import { render, staticRenderFns } from "./AddService.vue?vue&type=template&id=99bc939c&"
import script from "./AddService.vue?vue&type=script&lang=js&"
export * from "./AddService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports